import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';


/**
 * ProtectedRoute
 * 
 * Reads live permission set from Redux
 * 
 * Props:
 *   permission  {string} - required permission codes to access this route
 *   children    {ReactNode}
 *
 */
// const ProtectedRoutes = ({ children, allowedRoles, permission }) => {
const ProtectedRoutes = ({ children, permission }) => {
  const isAuthenticated = JSON.parse(sessionStorage.getItem("isAuthenticated"));
  const officer = JSON.parse(sessionStorage.getItem("officer")) || null;
  // const role = officer?.roleMaster?.role_name;
  const role = officer?.roleMaster?.short_name;
  const { officerProfile, officerPermissions } = useSelector((store) => {
    return {
      officerProfile: store.UserReducer.officerProfile,
      officerPermissions: store.UserReducer.officerPermissions,
    }
  });

  // Check auth FIRST — if not logged in, always go to login, never /unauthorized
  if(!officer || !isAuthenticated){
    return <Navigate to="/" replace />;
  }

  // Logged in but missing permission → back to login (or a /unauthorized page)
  if (permission && !officerPermissions?.has(permission)) {
    // return <Navigate to="/" replace />;
    return <Navigate to="/unauthorized" replace />;
  }
  // if (!allowedRoles.includes(role)) {
  //   return <Navigate to="/" />; // redirect to login
  // }

  return <>{children}</>;

  // return isAuthenticated ? children : <Navigate to="/" />;
}

export default ProtectedRoutes;